import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import ActionButtonsContainer from '../../actionButtons/ActionButtonsContainer';
import Grid from '@material-ui/core/Grid';
import actionButtonsStyles from '../../../presentational/actionButtons/ActionButtonsStyles';
import useIsTablet from '../../../../../common/react/useIsTablet';

export interface IActionButtonsGridElementProps {
  disabled: boolean;
}

const ActionButtonsGridElement: FC<IActionButtonsGridElementProps> = ({ disabled }) => {
  const styles = actionButtonsStyles();
  const isGridElementVisible = !useIsTablet();

  if (!isGridElementVisible) {
    return null;
  }

  return (
    <Grid item={true} lg={4} xs={12} className={styles.container}>
      <Box display="flex" alignItems="center" justifyContent="center">
        <ActionButtonsContainer disabled={disabled} />
      </Box>
    </Grid>
  );
};

export default ActionButtonsGridElement;
